/**
 * Textos do app (rotas, boot, "Sem acesso", páginas em construção). SPEC 9.11: pt-BR,
 * caixa de frase, sem exclamação na interface.
 */
import type { RouteId } from './permissions';

export const ROUTE_TITLES: Readonly<Record<RouteId, string>> = {
  hoje: 'Hoje',
  decisoes: 'Decisões',
  trafego: 'Tráfego',
  criativos: 'Criativos',
  funil: 'Funil e Quiz',
  vsl: 'VSL',
  perfis: 'Perfis',
  vendas: 'Vendas',
  recuperacao: 'Recuperação',
  financeiro: 'Financeiro',
  rastreamento: 'Rastreamento',
  relatorios: 'Relatórios',
  pauta: 'Pauta do Expert',
  ajustes: 'Ajustes',
  tv: 'Modo TV',
  backend: 'Backend',
  plano: 'Plano',
};

/** Propósito de cada tela (3.1), usado nas páginas em construção. */
export const ROUTE_PURPOSE: Readonly<Record<RouteId, string>> = {
  hoje: 'Estado do dia em 5 segundos: dinheiro, meta, ritmo, o que fazer agora e o que está acontecendo.',
  decisoes: 'O copiloto do dia: o que fazer, por quê, quanto vale e quem decide.',
  trafego: 'Cada campanha, conjunto e anúncio com o custo da Meta e o resultado real da Kiwify e da VTurb.',
  criativos: 'Quais ganchos e ângulos trazem comprador bom, e quando trocar um criativo.',
  funil: 'Funil unificado, cascata do CPA, perda por pergunta e respostas do quiz.',
  vsl: 'Retenção por segundo, oferta aos 17:35, clique no botão, origem e upsell.',
  perfis: 'Desempenho por resposta do quiz e o comprador do dia.',
  vendas: 'Pedidos ao vivo, pagamentos, upsell, reembolsos e conciliação.',
  recuperacao: 'Fila de trabalho: recusados, Pix, carrinhos e boletos, com prazo e dono.',
  financeiro: 'DRE do período, lucro em risco, caixa e unit economics.',
  rastreamento: 'Saúde do tracking, integrações, vendas não trackeadas e eventos.',
  relatorios: 'Briefings dos checkpoints e relatório semanal.',
  pauta: 'O que o público está dizendo, em linguagem de pauta para o Tiago.',
  ajustes: 'Metas, custos, limiares, usuários, integrações, notificações, aparência e simulação.',
  tv: 'Faturamento, funil, campanhas e vendas em tela cheia para a sala.',
  backend:
    'Consultorias de R$ 100 mil: do 20X ao contrato, etapa por etapa, sem envio pelo WhatsApp do Tiago.',
  plano:
    'Plano de 90 dias: fases, os 12 furos com medida ao vivo, placar de maturidade e a revisão de segunda.',
};

export const appCopy = {
  brand: 'Rota',
  brandSubtitle: 'Central ao vivo do Do Zero aos EUA',
  documentTitle: (page: string): string => `${page} · Rota`,
  boot: {
    loading: 'Abrindo a Rota',
    loadingHint: 'Carregando os números de hoje',
    errorTitle: 'Não foi possível abrir a Rota',
    errorText: 'O provedor de dados não respondeu. Tente de novo em alguns segundos.',
    retry: 'Tentar de novo',
    code: (code: string): string => `Código: ${code}`,
  },
  noAccess: {
    title: 'Sem acesso',
    text: (role: string): string => `O papel ${role} não vê esta tela.`,
    action: 'Ir para a minha tela inicial',
  },
  notFound: {
    title: 'Página não encontrada',
    text: 'O endereço não existe ou mudou de lugar.',
    action: 'Ir para a minha tela inicial',
  },
  routeError: {
    title: 'Não foi possível carregar esta tela',
    text: 'As outras telas continuam funcionando.',
    retry: 'Tentar de novo',
  },
  routeLoading: 'Carregando a tela',
  placeholder: {
    badge: 'Em construção',
    text: 'Esta tela chega na próxima onda. Os dados, os atalhos e as permissões já estão ligados.',
  },
  fixtureNotice: 'Dados de demonstração: cenário normal às 14:32',
  dev: {
    components: 'Galeria de componentes',
    charts: 'Galeria de gráficos',
  },
} as const;
